import { Grid, IconButton, TextField } from '@material-ui/core';
import { useContext } from 'react';
import { compose } from 'recompose';
import { Context, ContextProvider } from './store';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import Snackbar from '@/components/Snackbar';
import { OnwardSwitch, PageTitle, PrimaryButton } from '@/styles/blocks';
import { OnwardTextField } from '@/components/ShipmentForm/modals/InputFields';
import { DeleteForeverOutlined } from '@material-ui/icons';

const AdminTags = () => {
    const { state, loading, callbacks } = useContext(Context);

    return (
        <Grid
            container
            direction="column"
            css={css`
                height: 100%;
                background: ${colors.white.primary};
                flex-wrap: nowrap;
            `}
        >
            <Snackbar
                open={!!state.notification.message}
                {...state.notification}
                handleClose={() => callbacks.setNotification({})}
            />
            <Grid
                container
                css={css`
                    padding: 23px 45px;
                    border-bottom: 1px solid ${colors.greys[4]};
                    align-items: center;
                `}
            >
                <PageTitle>Accessorial Tags</PageTitle>
            </Grid>
            <Grid
                container
                direction="column"
                css={css`
                    flex-grow: 1;
                    padding: 12px max(10%, 48px);
                    flex-wrap: nowrap;
                    overflow-y: scroll;
                `}
            >
                {state.tags.map((tag) => (
                    <Grid
                        key={tag.tag_id}
                        container
                        css={css`
                            padding: 12px 0;
                            align-items: center;
                        `}
                    >
                        <Grid
                            item
                            css={css`
                                width: 300px;
                            `}
                        >
                            <OnwardTextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                value={tag.tag}
                                InputLabelProps={{ shrink: true }}
                                label="Tag Name"
                                onChange={(e) => callbacks.updateTag({ ...tag, tag: e.target.value })}
                            />
                        </Grid>
                        <Grid
                            item
                            css={css`
                                margin-left: 12px;
                            `}
                        >
                            <OnwardSwitch
                                label="Item Tag"
                                checked={tag.item_tag}
                                onChange={(e) => callbacks.updateTag({ ...tag, item_tag: e.target.checked })}
                            />
                        </Grid>
                        <Grid
                            item
                            css={css`
                                margin-left: 12px;
                            `}
                        >
                            <IconButton onClick={() => callbacks.removeTag(tag)}>
                                <DeleteForeverOutlined
                                    css={css`
                                        color: ${colors.reds.primary};
                                    `}
                                />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))}
                <Grid
                    item
                    css={css`
                        padding: 12px 0;
                    `}
                >
                    <PrimaryButton onClick={() => callbacks.createTag()}>Add Tag</PrimaryButton>
                </Grid>
            </Grid>
        </Grid>
    );
};

const withContext = (Component) => (props) =>
    (
        <ContextProvider>
            <Component {...props} />
        </ContextProvider>
    );

export default compose(withContext)(AdminTags);
